module.exports = __webpack_public_path__ + "static/img/remenLong.ed2446b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/remenLong.png
// module id = CzQz
// module chunks = 1